import './Page.css'

function Mission() {
  return (
    <div className="page-container">
      <h1>Our Mission</h1>
      <p>
        Our mission is simple: make high‑quality repair and reference documentation for
        electronic circuits and hardware freely available, forever.
      </p>
      <p>
        Commercial services exist, but they often sit behind paywalls, with unclear
        provenance and no path for the community to improve or correct mistakes. Alchemy
        Forum is built around the opposite idea: open access, transparent versioning,
        and a clear audit trail of who contributed what.
      </p>
      <p>
        We aim to:
      </p>
      <ul>
        <li>Preserve important schematics and reverse‑engineering work before they vanish.</li>
        <li>Encourage careful, well‑documented reconstructions instead of loose screenshots and forum posts.</li>
        <li>Give contributors clear credit and a history of their work.</li>
        <li>Provide a safe, well‑moderated space for sharing sensitive technical information responsibly.</li>
      </ul>
      <p>
        The roadmap includes structured metadata, review workflows, and clear licensing
        guidance so that repositories can be cited, re‑used, and built upon without guesswork.
        Over time, we want this to feel less like a forum thread archive and more like a
        living technical library.
      </p>
    </div>
  )
}

export default Mission

